import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getNormativeList as getNormativeListApi,
	getNormative as getNormativeApi,
	addNewNormative as addNewNormativeApi,
	updateNormative as updateNormativeApi,
	deleteNormative as deleteNormativeApi,
} from '../../helpers/normative/backend_helper';

export const getNormativeList = createAsyncThunk('normatives/getNormativeList', async () => {
	try {
		const response = getNormativeListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getNormative = createAsyncThunk('normatives/getNormative', async normative_id => {
	try {
		const response = getNormativeApi(normative_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewNormative = createAsyncThunk('normatives/addNewNormative', async normative => {
	try {
		const response = addNewNormativeApi(normative);
		toast.success('Normative agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar normative.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateNormative = createAsyncThunk('normatives/updateNormative', async (normative) => {
		try {
			const response = updateNormativeApi(normative);
			toast.success('Normative actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar normative.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteNormative = createAsyncThunk('normatives/deleteNormative', async normative => {
	try {
		const response = await deleteNormativeApi(normative);
		toast.success('Normative eliminado exitosamente.', { autoClose: 3000 });
		return { normative, ...response };
	} catch (error) {
		toast.error('Error al eliminar normative.', { autoClose: 3000 });
		throw new Error(error);
	}
});
